import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { CallsDataParams, getCallsData } from 'services/api/getCallsData';
import { queryKeys } from '../queryKeys';

export const useGetCallsData = (params: CallsDataParams, isEnabled = false, isRefetch = false) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.callsData(params),
        queryFn: () => getCallsData(params),
        placeholderData: keepPreviousData,
        refetchInterval: isRefetch ? 10000 : false,
        enabled: isEnabled,
    });

    return {
        callsData: data,
        isCallsDataLoading: isLoading,
        isCallsDataFetching: isFetching,
        ...rest,
    };
};
